import { useTranslations } from 'next-intl'

export const StartDate: React.FC<{ time: string }> = ({ time }) => {
  const t = useTranslations()
  return (
    <>
      <span className='bg-navy bg-airplane absolute top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-center bg-no-repeat p-2 ltr:-left-6 rtl:-right-0'></span>
      <p className='absolute top-7 mb-1 flex w-max -translate-x-1/2 flex-col items-start justify-center ltr:-left-0 rtl:right-0'>
        <span className='text-grey-50 font-medium'>{t('forms.landing')}</span>
        <span className='font-medium'>{time}</span>
      </p>
    </>
  )
}
